import { useEffect, useState } from 'react';
import { getStorage, ref, listAll, getMetadata } from 'firebase/storage';

const THREE_DAYS_MS = 3 * 24 * 60 * 60 * 1000;

const useAudioFiles = () => {
  const [audioFiles, setAudioFiles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAudioFiles = async () => {
      const storage = getStorage();
      const storageRef = ref(storage);

      try {
        const listResult = await listAll(storageRef);
        const filePromises = listResult.items.map(async (item) => {
          const metadata = await getMetadata(item);
          const timeCreated = new Date(metadata.timeCreated);
          return {
            name: item.name,
            ref: item,
            timeCreated,
            isNew: new Date() - timeCreated < THREE_DAYS_MS,
          };
        });

        const files = await Promise.all(filePromises);
        files.sort((a, b) => b.timeCreated - a.timeCreated);
        setAudioFiles(files);
      } catch (error) {
        console.error('Error fetching audio files:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchAudioFiles();
  }, []);

  return { audioFiles, loading };
};

export default useAudioFiles;
